/**
 * Client-side filters for `sharedAgendaItems` (entity-wide query + local filter).
 */

export const preMeetingEventId = (entityId: string) => `${entityId}__preMeeting`;

export function sharedAgendaItemVisibleInMeeting(
  data: Record<string, unknown>,
  ctx: { entityId: string; roomName: string; eventId?: string },
): boolean {
  if (data.entityId !== ctx.entityId) return false;
  if (data.deletedAt != null) return false;
  if (data.preMeetingEntity === true) return true;
  const eventKey = ctx.eventId ?? ctx.roomName;
  if (data.meetingRoom === ctx.roomName) return true;
  if (data.createdInMeeting === ctx.roomName) return true;
  if (data.eventId === eventKey) return true;
  if (data.eventId === ctx.roomName) return true;
  return false;
}

export function sharedAgendaItemVisibleOnDashboard(
  data: Record<string, unknown>,
  entityId: string,
): boolean {
  if (data.entityId !== entityId) return false;
  if (data.deletedAt != null) return false;
  if (data.preMeetingEntity === true) return true;
  return data.eventId === preMeetingEventId(entityId);
}
